import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Inherit sessionStorage from opener tab (covers ctrl+click, middle-click,
// right-click "open in new tab" — Chrome's auto-clone is unreliable for ctrl +click)
// if (window.opener && window.opener.location.origin === window.location.origin) {
//   try {
//     const openerStorage = window.opener.sessionStorage;
//     for (let i = 0; i < openerStorage.length; i++) {
//       const key = openerStorage.key(i);
//       if (!sessionStorage.getItem(key)) {
//         sessionStorage.setItem(key, openerStorage.getItem(key));
//       }
//     }
//   } catch (err) {
//     // cross-origin or blocked — ignore, falls through to normal login flow
//   }
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
